<template>
  <div v-if="showRouter" id="app">
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" /> -->
    <router-view />
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      showRouter: false
    };
  },
  computed: {
    ...mapGetters(["privilegeConfig", "adminInfo", "firstPath"])
  },
  watch: {
    privilegeConfig() {
      console.log("权限变化");
    },
    adminInfo() {
      console.log("adminInfo变化");
    }
  },
  methods: {
    ...mapActions(["fetchPrivilege", "initSocket"]),
    ...mapMutations(["setAdminInfo"]),
    checkLoginChange() {
      setTimeout(() => {
        this.checkLoginChange();
      }, 1500);
    }
  },
  mounted() {},
  async created() {
    this.showRouter = true;
    // window.addEventListener("storage", async e => {
    //   console.log("storage变化", e);
    //   let key = e.key;
    //   if (key == "changeFactory") {
    //     await this.fetchPrivilege();
    //     this.$router.push("/rhqy/lyout");
    //     location.reload(true);
    //   }
    // });
    // // 检验登录
    // const checkRs = await this.$common.http({
    //   url: "/api/authorize/check_login"
    // });
    // if (Number(checkRs.data.data.logined) == 1) {
    //   // 保存当前用户信息
    //   this.setAdminInfo(checkRs);
    //   // socket链接
    //   // this.initSocket();
    //   // 获取权限
    //   await this.fetchPrivilege();
    //   this.showRouter = true;
    //   console.log(
    //     "当前用户权限Privilege",
    //     this.privilegeConfig,
    //     this.firstPath
    //   );
    //   // 跳转到页面
    //   if (this.$route.path === "/rhqy/login") {
    //     this.$router.push("/rhqy/lyout");
    //   }
    //   this.checkLoginChange();
    // } else {
    //   this.showRouter = true;
    // }
  }
};
</script>
<style scoped lang="less">
#app {
  width: 100%;
  height: 100%;
  min-width: 1408px;
  overflow-x: auto;
  overflow-y: hidden;
}
</style>
<style lang="less">
body {
  margin: 0;
}
</style>
